import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'server/types/ServerPageInterface'
import { migrateCommand } from '../utils/migrateCommand'
import { migrateBlogPostLayoutBody } from './migrateBlogPostLayoutBody'

export default function (page: ServerPage) {
  return migrateCommand({
    page,
    structureType: structureTypes.BLOG_POST_LAYOUT_BODY,
    migrateFunction: migrateBlogPostLayoutBody,
  })
}
